export default __webpack_public_path__ + "static/media/potato.efe6c7e6.png";